








































import { Component } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CustomerTwism from '@/components/icons/CustomerTwism.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';
import BillingModel from '../Models/BillingModel.vue';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    FilledButton,
    CustomerTwism,
    CoinNetworkFeatureTag
  }
})
export default class ActivationEmailsEmptyState extends BillingModel {
  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'emailAutomation.empty';
  }

  get tBtn() {
    return `btn${this.inactiveBilling ? 'Upgrade' : ''}`;
  }

  onClickCTA() {
    if (this.inactiveBilling) {
      this.onClickUpgrade({
        onSuccess: () => {
          this.$emit('click');
        },
        props: {
          welcomeCtaText: 'Explore Email Automation',
          origin: 'Empty State Email Automation'
        }
      });
      return;
    }
    this.$emit('click');
  }
}
